import { HeroSection } from '@/components/home/HeroSection';
import { ServicesSection } from '@/components/home/ServicesSection';
import { StatsSection } from '@/components/home/StatsSection';
import { CTASection } from '@/components/home/CTASection';
import { LeadCaptureForm } from '@/components/forms/LeadCaptureForm';

export default function HomePage() {
  return (
    <div className="pt-20">
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      
      {/* B2B Lead Capture Section */}
      <section className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-title mb-4">
            Let&apos;s Create Something <span className="text-gradient-silver">Extraordinary</span>
          </h2>
          <p className="text-base text-body max-w-2xl mx-auto">
            Share your vision with us. Whether it&apos;s a corporate event, personalized gifts, or innovative NFC solutions.
          </p>
        </div>
        <LeadCaptureForm 
          cardId="homepage"
          buttonText="שלח פנייה / Send Inquiry"
        />
      </section>

      <CTASection />
    </div>
  );
}
